import React from 'react';
import { PTAssignmentComponent } from './pt-assignment.component';
import { useListEmployees } from '../../utils/api-hooks/employee.hook';
import { useListLocation } from '../../utils/api-hooks/location.hook';
import {
  useLocationAssistantReportShifts,
  usePTSchedule,
  useUpdatePTScheduleShift,
  useToggleScheduleDateIsWaitingForArrange,
  useEmployeeLocationHistory,
} from '../../utils/api-hooks/pt-schedule.hook';
import { useParams } from 'react-router-dom';

export const PTAssignmentContainer: React.FC = () => {
  const { scheduleId } = useParams<{ scheduleId: string }>();

  // 取得班表
  const { data: schedule } = usePTSchedule(scheduleId!);

  // 獲取建築物數據
  const { data: locations, isLoading: isLoadingLocations } = useListLocation();

  // 獲取員工數據
  const { data: { data: employees = [] } = {}, isLoading: isLoadingEmployees } =
    useListEmployees();

  const { data: { data: shifts } = {}, isLoading: isLoadingShifts } =
    useLocationAssistantReportShifts(schedule?.startTime, schedule?.endTime);

  // 獲取員工歷史排班場域
  const { data: employeeLocationHistory } = useEmployeeLocationHistory(
    schedule?.startTime
  );

  const { mutateAsync: updateShift, isLoading: isLoadingUpdateShift } =
    useUpdatePTScheduleShift();

  const { mutateAsync: toggleWaitingForArrange } =
    useToggleScheduleDateIsWaitingForArrange();

  const isLoading =
    isLoadingLocations ||
    isLoadingEmployees ||
    isLoadingUpdateShift ||
    isLoadingShifts;

  return (
    <PTAssignmentComponent
      schedule={schedule}
      locations={locations}
      employees={employees}
      reportShifts={shifts || []}
      employeeLocationHistory={employeeLocationHistory?.data || []}
      updateShift={updateShift}
      toggleWaitingForArrange={toggleWaitingForArrange}
      isLoading={isLoading}
    />
  );
};
